import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Dashboard, Summary } from '|/app/services';

const defaultProps = {
  dashboard: null as null | Dashboard,
  summary: null as null | Summary
};

const DataLoadRedirect: React.FC<React.PropsWithChildren<typeof defaultProps>> = ({
  dashboard,
  summary,
  children
} = defaultProps) => {
  const location = useLocation();

  if (dashboard === null || summary === null) {
    return (
      <Navigate
        to={`/?return-url=${encodeURIComponent(`${location.pathname}${location.hash}${location.search}`)}`}
        replace={true}
      />
    );
  }

  return <>{children}</>;
};

export default DataLoadRedirect;
